import { DataService } from '../../../services/data_service';

export function saveInChunks(data: Array<any>, dataService: DataService, entity: string, modul: string,  callback: () => void) {
    const chunks: Array<Array<any>> = [];
    const chunksize = 40;
    data.forEach((d: any, idx: number) => {
        const chunk = (idx - (idx % chunksize)) / chunksize;
        if (!chunks[chunk]) {
            chunks[chunk] = [];
        }
        chunks[chunk].push(d);
    });
    saveChunk(chunks, 0, dataService, entity, modul, callback);
}

function saveChunk(chunks: Array<Array<any>>,  idx: number, dataService: DataService, entity: string, modul: string, callback: () => void) {
    if (!chunks[idx]) {
      //  console.log('SAVEING CHUNKS: DONE');
        callback();
        return;
    }
    dataService.saveDataList(entity, chunks[idx], () => {
        saveChunk(chunks, idx + 1, dataService, entity, modul, callback);
    }, modul);
}
